import * as React from "react";
import DynamicLayout from "../components/DynamicLayout";

const NotFoundPage = () => (
  <DynamicLayout>
    <div>
      <h1>NOT FOUND</h1>
      <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
    </div>
  </DynamicLayout>
);

export default NotFoundPage;
